import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  ModalService,
  TileV2Module,
  ButtonV2Module,
  FileUploadV2Module,
} from '@schenck/rotec-components';
import { routes } from 'src/routes';
import { ToolingInfoWithKpi } from 'src/services';
import { ToolingDetailsModalComponent } from '../../tooling-details-modal/tooling-details-modal.component';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ma-tooling-tile',
  templateUrl: './tooling-tile.component.html',
  styleUrls: ['./tooling-tile.component.less', '../tile-styles.less'],
  imports: [TileV2Module, TranslateDirective, ButtonV2Module, AsyncPipe, FileUploadV2Module],
})
export class ToolingTileComponent {
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);

  @Input()
  tooling: ToolingInfoWithKpi;

  openDetails() {
    this.modalService.open(ToolingDetailsModalComponent, this.tooling);
  }

  showTasks() {
    this.router.navigate([routes.toolingTasks.absoluteUrl], {
      queryParams: { [routes.toolingTasks.params.tooling]: this.tooling.name },
    });
  }
}
